var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProcess03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 37.3008H30M17.5 47.3008H47.5M77.5 45.2008V9.80078C77.5 8.41828 76.3825 7.30078 75 7.30078H5C3.6175 7.30078 2.5 8.41828 2.5 9.80078V59.8008C2.5 61.1833 3.6175 62.3008 5 62.3008H41.2",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5998 62.4C77.5998 54.4512 71.1486 48 63.1998 48C55.251 48 48.7998 54.4512 48.7998 62.4C48.7998 70.3488 55.251 76.8 63.1998 76.8C71.1486 76.8 77.5998 70.3488 77.5998 62.4Z",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7998 4.59961C8.7998 2.94276 10.143 1.59961 11.7998 1.59961H16.9998C18.6567 1.59961 19.9998 2.94276 19.9998 4.59961V23.3662C19.9998 24.2301 18.9782 24.6875 18.3338 24.1121L15.0658 21.1943C14.6864 20.8555 14.1132 20.8555 13.7338 21.1943L10.4658 24.1121C9.82141 24.6875 8.7998 24.2301 8.7998 23.3662V4.59961Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6001 60L63.2001 65.6L68.8001 60",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcess03);
export default __webpack_public_path__ + "static/media/icon_process_03.0f20f3df8205b12ed6ab50a2ba3a93eb.svg";
export { ForwardRef as ReactComponent };